import { render, staticRenderFns } from "./zhitongche.vue?vue&type=template&id=afaa72ae&scoped=true&"
import script from "./zhitongche.vue?vue&type=script&lang=js&"
export * from "./zhitongche.vue?vue&type=script&lang=js&"
import style0 from "./zhitongche.vue?vue&type=style&index=0&id=afaa72ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaa72ae",
  null
  
)

export default component.exports